
"use strict"; // jshint ignore:line

window.DEBUG = (location.search.indexOf("debug=false")==-1) && location.host != "artest.net";
window.scope = function( elem ){ return angular.element(elem || window.$0).scope(); };

import './ajs/ajs.app.js';

if (!window.MODEL_VIEWER) {

	angular.module( "gameApp" )

	.config(["$stateProvider","$urlRouterProvider","$controllerProvider",
	function( $stateProvider,  $urlRouterProvider,  $controllerProvider ) {

		$urlRouterProvider.otherwise( 'arrangements' );

		$stateProvider.state("arrangements", {
			templateUrl : "src/js/components/scene-selector-view/scene-selector-view.template.html",
			controller  : "view.scene-selector",
			url         : "/arrangements?arrangement_uid&uid&mode",
			resolve: {
				"ctrl": window.controllerResolver( "view.scene-selector" ),
				"user": [ "$User", function( $User ) {
					return $User.__ready.promise.catch(function( error ) {

						console.error( error );

					}).then(function() {

						if (!$User.logged) {
							location.href = "/auth/login?redirect="+ encodeURIComponent( location.pathname + location.hash );
						}
					});
				}]
			}
		});
	}])

		
	// RUN	
	.run([   "$state","artestUserBarService",
	function( $state,  artestUserBarService ) {

		artestUserBarService.brandingLogoClick = function() {
			switch ($state.current.name) {
				case "scene":
					if (window.confirm( "Oletko varma, että haluat poistua 3D-suunnittelusta? Tallentamattomat muutokset menetetään.")) {
						$state.go("arrangements", {
							arrangement_uid: $state.params.arrangement_uid
						});
					}
			}
		};
	}])

} else {
	angular.module( "gameApp" )

	.config(["$urlRouterProvider",
	function( $urlRouterProvider ) {
		$urlRouterProvider.otherwise( 'scene' );
	}])

	.run([ "$uibModal", "artestUserBarService", "$q", "$ApiHandler", function( $uibModal, artestUserBarService, $q, $ApiHandler ) {

		artestUserBarService.brandingLogoClick = angular.noop;

		window.WELCOME_MODAL = $uibModal.open({
			templateUrl: "templates/viewer-welcome-modal.html",
			windowTopClass: "welcome-modal",
			size: "lg",
			animation: false
		});

		window.WELCOME_MODAL.stime = Date.now();

		window.WELCOME_MODAL.result = window.WELCOME_MODAL.result.catch(function( error ) {
			console.error( error );
		}).then(function(){
			delete window.WELCOME_MODAL;
		});


		if (!window.ARRANGMENT_UID) try {
			let match = location.search.match( /arrangement_uid=(A5[A-F0-9]{14})/ ) || location.hash.match( /arrangement_uid=(A5[A-F0-9]{14})/ );

			if (match) {
				window.ARRANGMENT_UID = match[ 1 ];
			}

		} catch (error) { console.error( error ); }

		if (window.ARRANGMENT_UID) {

			var prms = window.ARRANGMENTS;
			try {
				prms = prms || $ApiHandler.findOrGet( "/model_preview/arrangements/"+window.ARRANGMENT_UID+"?filters=asarray,onlydata,onlyattrs&with=model" );
			} catch (error) {
				prms = prms || $ApiHandler.get( "/model_preview/arrangements/"+window.ARRANGMENT_UID+"?filters=asarray,onlydata,onlyattrs&with=model" );
			}
		}

	}])
}
